import React, { Component } from 'react';
import Context from '../../tools/context';
import { authClient } from '../../tools/apitools';
import '../../style/TicketsPage.scss';
import moment from 'moment';
import Ticket from "./ticket";
import {clientT} from "../../tools/i18n";
import ConfirmedTicket from "../../components/ConfirmedTicket";
import AppLink from "../../components/AppLink";

class MyTicketsUsed extends Component {
    constructor() {
        super();
        this.state = {
            tickets: [],
            selectedTicket: null,
        }
        moment.locale('fr');
        this.getGifts();
    }

    onGetGiftResponse = (res) =>{
        if (!res) {
            this.setState({tickets: ['not']});
            return;
        }
        const buffer = res.filter(ticket => (ticket.used)).sort((a, b) => new Date(b.burnDate) - new Date(a.burnDate));
        if (buffer.length !== 0)
            this.setState({tickets: buffer});
        else
            this.setState({tickets: ['not']});
    }

    onGetGiftError = (status, err) => {
        console.error('Either customerId is incorrect or partner is not correctly set', err);
        this.setState({tickets: ['not']});
        // this.props.history.push('temporary');
    }

    getGifts = async () => {
            authClient(`api/bienvenus/user/ticket?customer=${Context.partner.customerId}`, {method: 'GET'},
              this.onGetGiftResponse,this.onGetGiftError);
    }

    handleSelection = (selectedTicket) => {
        console.log(selectedTicket)
        this.setState({selectedTicket})
    }

    toDisplay = () => {
        const { tickets } = this.state;

        if (tickets[0] !== 'not')
            return (
                <>
                    <div className='used'>
                        <div className="ticketList">
                            {tickets.map((ticket, index) => <Ticket
                              ticket={ticket}
                              index={index}
                              handleSelection={this.handleSelection}
                            />)}
                        </div>
                    </div>
                </>
            );
        else
            return (
                <div>
                    <p>{clientT('usedTickets.noTicket')}</p>
                </div>
            );
    }

    render () {
        return (
            <div className='my-tickets-container'>
                <h1 className="title">{clientT('usedTickets.title')}</h1>
                <hr />
                {this.toDisplay()}
                {this.state.selectedTicket && <div className="popupRecapUsed">
                    <ConfirmedTicket
                  selectedTickets={[this.state.selectedTicket]}
                  sellerName={this.state.selectedTicket.sellerRecipient}
                  sellerShortCode={this.state.selectedTicket.sellerRecipientId}
                  reset={() => this.setState({selectedTicket: null})}
                  popup
                    /></div>}
            </div>
        )
    }
}

export default MyTicketsUsed;
